import PageMeta from "../../components/common/PageMeta";
import { Outlet } from "react-router-dom";
import { useRole, UserRole } from "../../context/RoleContext";

export type DataManagementTabName =
  | "Hotel Info"
  | "Restaurants"
  | "Menu Items"
  | "Room Service"
  | "Housekeeping"
  | "Facilities"
  | "Special Events"
  | "Special Products";

export const allTabs: DataManagementTabName[] = [
  "Hotel Info",
  "Restaurants",
  "Menu Items",
  "Room Service",
  "Housekeeping",
  "Facilities",
  "Special Events",
  "Special Products",
];

// Helper function to determine if a tab should be visible for a given role.
// This mirrors the previous tab-visibility behavior and is also reused
// by the sidebar to hide Data Management sub-items per role.
export const canShowDataTab = (
  tabName: DataManagementTabName,
  role: UserRole,
): boolean => {
  // Hotel Info is ADMIN only
  if (tabName === "Hotel Info") {
    return role === "ADMIN";
  }

  if (role === "ADMIN" || role === "MANAGER") {
    return true;
  }

  if (role === "STAFF") {
    const restrictedTabs: DataManagementTabName[] = [
      "Restaurants",
      "Menu Items",
      "Room Service",
      "Special Events",
      "Special Products",
    ];
    return !restrictedTabs.includes(tabName);
  }

  // Default to not showing if role is UNKNOWN or not matched
  return false;
};

export default function DataManagement() {
  const { userRole } = useRole();

  const hasAnyVisibleTab = allTabs.some((tab) =>
    canShowDataTab(tab, userRole),
  );

  if (!hasAnyVisibleTab) {
    return (
      <>
        <PageMeta
          title="Data Management - SelfServe"
          description="SelfServe Data Management Dashboard"
        />
      </>
    );
  }

  return (
    <>
      <PageMeta
        title="Data Management - SelfServe"
        description="SelfServe Data Management Dashboard"
      />
      {/* Data Management header temporarily disabled */}
      {/* <div className="overflow-hidden pl-3">
        <div className="flex flex-col gap-2 mb-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="mb-10">
            <h3 className="text-2xl font-semibold pt-5 pb-3 text-gray-800 dark:text-white/90">
              Data Management
            </h3>
            <p className="text-[16px] font-light text-gray-400">
              Manage and view all your hotel data in one place.
            </p>
          </div>
        </div>
      </div> */}
      <div className="tab-content">
        <Outlet />
      </div>
    </>
  );
}
